module.exports = __webpack_public_path__ + "media/images/admin/icons/volume-a715247a114af7d4e171d3bc9ecb369e.svg";